module.exports = __webpack_public_path__ + "img/53_31.6a6634c2.png";